"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WSServiceAudioInstance = void 0;
const nest_interconnectors_1 = require("@rws-framework/nest-interconnectors");
class WSServiceAudio extends nest_interconnectors_1.WSServiceInstance {
    setPortHandler() {
        this.url = process.env.WS_AUDIO_URL;
    }
}
exports.WSServiceAudioInstance = WSServiceAudio;
exports.default = WSServiceAudio.getSingleton();
